export function trackEvent(eventName, error = false, errorMessage = null, customAttributes = {}) {
    if (!window.newrelic) {
        console.warn('New Relic is not initialized.');
        return;
    }

    const attributes = {
        error: error,
        error_message: errorMessage || 'No Error',
        ...customAttributes,
    };

    window.newrelic.addPageAction(eventName, attributes);

    if (error) {
        console.error(`${eventName}: ${errorMessage}`);
    } else {
        console.log(`${eventName}: No errors, additional attributes:`, customAttributes);
    }
}
